module.exports = __webpack_public_path__ + "static/media/purityx-4.6e95dfbe.png";